<div class="has-text-centered">
    <p class="has-text-weight-bold">Votre panier est vide</p>
    <span class="icon is-large"><i class="tri-shopping-bag"></i></span>
</div>
